import { ApiProvider } from '@src/app/context/Api';
import { RoutesProvider } from '@src/app/context/Routes/Routes';
import { UserProvider } from '@src/entities/User/ui/context';
import { VisibilityProvider } from '@src/entities/User/ui/context/Visibility';
import React from 'react';

/**
 * ApplicationProvider
 *
 * Handles setting the context to be used globally throughout the application.
 *
 * @param children
 * @returns {Element}
 * @constructor
 */
export function ApplicationProvider({ children }) {
  return (
    <ApiProvider>
      <RoutesProvider>
        <UserProvider>
          <VisibilityProvider>{children}</VisibilityProvider>
        </UserProvider>
      </RoutesProvider>
    </ApiProvider>
  );
}
